const read = (...allOf) => ({
    allOf,
});
const write = (...allOf) => ({
    allOf: [...allOf, 'canWrite'],
});
const DOCUMENTS = 'canAccessDocuments';
const ACCOUNTS = 'canAccessAccounts';
const TREASURY = [
    'canAccessPayments',
    'canAccessAccounts',
    'canAccessDocuments',
];
const BILLABLE_CHARGE_SECTIONS = [
    'canAccessDocuments',
    'canAccessServiceContracts',
];
export const PUBLIC_API_SCOPE_REQUIRED_PERMISSIONS = {
    'tenant:read': read(),
    'tenant:write': write('canAccessSettings'),
    'counterparties:read': read('canAccessRegistry'),
    'counterparties:write': write('canAccessRegistry'),
    'accounts:read': read(ACCOUNTS, 'canViewAccountBalances'),
    'accounts:write': write(ACCOUNTS, 'canViewAccountBalances'),
    'movements:read': read(ACCOUNTS),
    'movements:write': write(ACCOUNTS),
    'categories:read': read('canAccessSettings'),
    'categories:write': write('canAccessSettings'),
    'documents:read': read(DOCUMENTS),
    'documents:write': write(DOCUMENTS),
    'documents:send': write(DOCUMENTS),
    'attachments:read': read(DOCUMENTS),
    'attachments:write': write(DOCUMENTS),
    'settings:read': read('canAccessSettings'),
    'settings:write': write('canAccessSettings'),
    'invoices:write': write(DOCUMENTS),
    'invoices:send': write(DOCUMENTS),
    'schedules:read': read('canAccessPaymentSchedules'),
    'schedules:write': write('canAccessPaymentSchedules'),
    'allocations:read': read(ACCOUNTS, DOCUMENTS),
    'allocations:write': write(ACCOUNTS, DOCUMENTS, 'canReconcile'),
    'reconciliation:read': read(ACCOUNTS, DOCUMENTS),
    'reconciliation:write': write(ACCOUNTS, DOCUMENTS, 'canReconcile'),
    'debts:read': read('canAccessAdministration'),
    'debts:write': write('canAccessAdministration'),
    'forecast:read': read('canAccessForecast'),
    'forecast:write': write('canAccessForecast'),
    'transfers:read': read(ACCOUNTS),
    'transfers:write': write(ACCOUNTS),
    'riba:read': read(...TREASURY),
    'riba:write': write(...TREASURY, 'canExecutePayments'),
    'invoice_advances:read': read(...TREASURY),
    'invoice_advances:write': write(...TREASURY),
    'collection_accounts:read': read('canAccessSettings'),
    'collection_accounts:write': write('canAccessSettings'),
    'payments:read': read('canAccessPayments'),
    'payments:execute': write('canAccessPayments', 'canExecutePayments'),
    'bank_imports:write': write(ACCOUNTS),
    'products:read': read('canAccessProducts'),
    'products:write': write('canAccessProducts'),
    'price_lists:read': read('canAccessProducts'),
    'price_lists:write': write('canAccessProducts'),
    'inventory:read': read('canAccessWarehouse'),
    'inventory:write': write('canAccessWarehouse'),
    'service_contracts:read': read('canAccessServiceContracts'),
    'service_contracts:write': write('canAccessServiceContracts'),
    'billable_charges:read': { allOf: [], anyOf: BILLABLE_CHARGE_SECTIONS },
    'billable_charges:write': {
        allOf: ['canWrite'],
        anyOf: BILLABLE_CHARGE_SECTIONS,
    },
    'projects:read': read('canAccessCommesse'),
    'projects:write': write('canAccessCommesse'),
    'recurring_invoices:read': read(DOCUMENTS),
    'recurring_invoices:write': write(DOCUMENTS),
    'carriers:read': read(),
    'carriers:write': write('canAccessSettings'),
    'locations:read': read(),
    // Il feed delle modifiche filtra già sugli altri scope di lettura concessi.
    'changes:read': read(),
    'jobs:read': read(),
    'webhooks:read': read(),
    'webhooks:write': write(),
};
/** Lo scope è concedibile da chi ha questi flag (bypass OWNER già risolto). */
export function canGrantPublicApiScope(scope, flags) {
    const requirement = PUBLIC_API_SCOPE_REQUIRED_PERMISSIONS[scope];
    if (!requirement)
        return false;
    const hasAll = requirement.allOf.every((flag) => flags[flag] === true);
    const hasAny = !requirement.anyOf ||
        requirement.anyOf.some((flag) => flags[flag] === true);
    return hasAll && hasAny;
}
/** Scope richiesti che il membro non può concedere, in ordine di input. */
export function findUngrantablePublicApiScopes(scopes, flags) {
    return [...new Set(scopes)].filter((scope) => !canGrantPublicApiScope(scope, flags));
}
//# sourceMappingURL=public-api-scope-permissions.js.map